import {
  PAGES,
  ACTIONS,
  METHODS,
  AUTH_API_URL
} from '../constants'
import R from 'ramda'

export const goToTab = ({
  pageName = PAGES.USER
}) => ({type: ACTIONS.NAVIGATION.GO_TO_TAB, pageName})

// navigation must have {pageName} , and typically has {pageNum, perPage, ids}
// can have other query args for filtered search
export const setNavigation = navigation => R.merge({type: ACTIONS.NAVIGATION.GO_TO}, navigation)

export const clearAuthError = () => ({type: ACTIONS.AUTH_STATUS.CLEAR_ERROR})

export const loginAndGoToPage = ({
  username = 'blah',
  password = 'blow',
  navigation = {}
}) => ({
  type: ACTIONS.AUTH_STATUS.LOGIN.START,
  actionSet: ACTIONS.AUTH_STATUS.LOGIN,
  method: METHODS.POST,
  payload: {username, password},
  url: `${AUTH_API_URL}/login`,
  onSuccessAction: {
    type: ACTIONS.NAVIGATION.GO_TO,
    pageName: R.propOr(PAGES.USERS, 'pageName', navigation),
    pageNum: R.propOr(1, 'pageNum', navigation),
    perPage: R.propOr(20, 'perPage', navigation),
    ids: R.propOr([], 'ids', navigation)
  }
})

export const logout = () => ({
  type: ACTIONS.AUTH_STATUS.LOGOUT.START,
  actionSet: ACTIONS.AUTH_STATUS.LOGIN,
  method: METHODS.POST,
  url: `${AUTH_API_URL}/logout`,
  onSuccessAction: {
    type: ACTIONS.NAVIGATION.GO_TO_LOGIN
  }
})



// WEBPACK FOOTER //
// ./webAdmin/actions/index.js